// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import store from "./store";
import "babel-polyfill";
import { loggedIn, beLogout } from "@/api/auth";
// import '@/assets/fonts/iconfont.css'
// import '../static/fonts/iconfont.css'
Vue.config.productionTip = false;
axios.defaults.timeout = 10 * 1000;
Vue.prototype.$axios = axios;
let isListPage = false;
/*
路由拦截，start
*/
/*
登录，鉴权，可以在这里统一处理
*/
router.beforeEach((to, from, next) => {
  //头部选中效果切换
  if (to.path === "/home") {
    store.commit("headerActive", "home");
  } else if (to.path === "/personalHome") {
    store.commit("headerActive", "personalHome");
  } else {
    store.commit("headerActive", to.name);
  }

  //个人中心进入注册页面需要进行权限验证，其他页面进入，无需验证
  let registerPath = "/register?step=2";

  if (
    to.matched.some(record => record.meta.requiresAuth) ||
    to.fullPath === registerPath
  ) {
    (async () => {
      let ret = await loggedIn();
      // let ret = "success"
      // 判断是否登录
      if (ret === "noLogin") {
        if (to.path === "/register") {
          // 特殊处理，register需要checkAuth
          next();
        } else {
          store.commit("changeRefreshHeader", {
            flag: true
          });
          if (to.path === "/home" || to.path === "/documentCenter") {
            next();
          } else {
            next({
              path: "/home"
            });
          }
        }
      } else if (ret === "forbidden") {
        //用户禁用后，进行强制登出操作
        let result = await beLogout();
        //跳转到首页
        if (result === "logout") {
          next({
            path: "/home"
          });
        }
      } else if (ret === "quitSystem") {
        next({
          path: "/logout"
        });
      } else {
        // 登录有效，判断是否有权限
        if (ret === "noAuth") {
          // 无权限
          next({
            path: "/page403",
            query: { redirect: to.fullPath }
          });
        } else {
          // 有权限
          next();
        }
      }
    })();
  } else {
    // 确保一定要调用 next()
    next();
  }
});
/*
路由拦截，end
 */

// router.afterEach((route) => {
//   debugger;
//   // 如果是needConfirm的页面，那么进入后要设置beforeunload
//   if (route.meta.needConfirm) {
//     // 不适用拦截的时候用这个
//     window.onbeforeunload = function (event) {
//       return  '页面未保存，确定离开此页面吗？'
//     }
//   }
//   else {
//     window.onbeforeunload = null
//   }
// })

/*
请求，响应拦截，start
 */

var __iflytekToken__ = "";
/*
发送请求前处理请求
 */
// Add a request interceptor
axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    config.headers["ecssafetytoken"] = __iflytekToken__;
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);
/*
接收响应时处理响应
 */
// Add a response interceptor
axios.interceptors.response.use(
  function(response) {
    if (response.headers["ecssafetytoken"]) {
      __iflytekToken__ = response.headers["ecssafetytoken"];
    }
    // Do something with response data
    if (
      response.data.code &&
      (response.data.code == "-9999" || response.data.code == "-9998") &&
      !isListPage
    ) {
      isListPage = true;
      let msgTip =
        response.data.code == "-9999"
          ? "应用已被平台管理员设置为非系统应用，请重新进入当前页面进行授权管理"
          : "应用已被平台管理员设置为系统应用，请重新进入当前页面进行授权申请";
      ElementUI.MessageBox.alert(msgTip, "提示", {
        confirmButtonText: "确定",
        type: "warning",
        callback: action => {
          router.push("/personalHome");
        }
      });
    } else {
      isListPage = false;
      return response;
    }
  },
  function(error) {
    // Do something with response error
    if (!error.response) {
      return Promise.reject(error);
    } else if (error.response.headers["sessionstatus"] === "no") {
      // router.push('/home')
    }
    return Promise.reject(error);
  }
);

/*
请求，响应拦截，end
 */

//页面跳转之后，滚动条滑动到页面顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta.needConfirm) {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    window.onbeforeunload = function(event) {
      if (
        userAgent.indexOf("compatible") > -1 &&
        userAgent.indexOf("MSIE") > -1
      ) {
        let isLeavePage = store.state.isLeavePage;
        if (isLeavePage == "1") {
          return "页面未保存，确定离开此页面吗？";
        }
        store.commit("isLeavePage", "1");
      } else {
        return "页面未保存，确定离开此页面吗？";
      }
    };
  } else {
    window.onbeforeunload = null;
  }
});

Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js